import * as yup from 'yup';

export const LcCancerDeProstataSchema = yup.object().shape({
  num_registro_pros: yup
    .number()
    .typeError('Campo obrigatório. Máximo 5 dígitos.')
    .required('Campo obrigatório'),
    dn_pros: yup.string().nullable(true),
    convenio_pros: yup.string().nullable(true),

    // Tratamento
    entrada_data_pros: yup.string().nullable(true),
    entrada_hora_pros: yup.string().nullable(true),
    cirurgia_tipo_pros: yup.string().nullable(true),
    cirurgia_via_pros: yup.string().nullable(true),
    paliativos_pros: yup.string().nullable(true),

    // Dados da doença
    psa_total_pros: yup.string().nullable(true),
    psa_livre_pros: yup.string().nullable(true),
    gleason1_pros: yup.string().nullable(true),
    gleason2_pros: yup.string().nullable(true),
    gleason_pros: yup.string().nullable(true),
    asa_pros: yup.string().nullable(true),
    t_pros: yup.string().nullable(true),
    n_pros: yup.string().nullable(true),
    m_pros: yup.string().nullable(true),

    // Laudo anatomopatológico da prostatectomia total
    tipo_oms_pros: yup.string().nullable(true),
    grau_gleason_pros: yup.string().nullable(true),
    extensao_pros: yup.string().nullable(true),
    invasao_pros: yup.string().nullable(true),
    status_margens_pros: yup.string().nullable(true),
    estadiamento_pros: yup.string().nullable(true),
    linfonodos_pros: yup.string().nullable(true),
    tnm_prontuario_pros: yup.string().nullable(true),

    // Complicações pós-cirúrgicas durante a internação
    cardio_pros: yup.string().nullable(true),
    trombo_pros: yup.string().nullable(true),
    transfusao_pros: yup.string().nullable(true),

    // Dados da saída
    covid_prostata: yup.string().nullable(true),
    saida_motivo_pros: yup.string().nullable(true),
    saida_data_pros: yup.string().nullable(true),
    saida_hora_pros: yup.string().nullable(true),
});
